// 站点品牌常量:对外联系方式等,全站唯一出处。
// 换企业邮箱(如 support@resguard.cn)时只改这里 —— 别再在页面里硬编码邮箱。
export const CONTACT_EMAIL = "shugesiwei@126.com"; // 公司邮箱(上海书格思帷科技有限公司)

/** 运营主体信息(用户协议/隐私政策/页脚展示用)。 */
export const COMPANY = {
  name: "上海书格思帷科技有限公司",
  creditCode: "91310112MAKDTH0R0M",
  address: "上海市闵行区剑川路600号第1幢",
  /** 工信部 ICP 备案号。按规定必须在网站首页底部标明,并链接到 beian.miit.gov.cn。 */
  icp: "沪ICP备2026037015号-1",
};

/** 工信部备案查询入口(备案号必须可点击跳转到这里)。 */
export const ICP_QUERY_URL = "https://beian.miit.gov.cn/";

/** 组装 mailto 链接(可带主题)。 */
export function mailto(subject?: string): string {
  return `mailto:${CONTACT_EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;
}
